export class ApplicationSearch {
  premiseId: string;
}
